import React from 'react'
import currency from "currency.js";
import { type WebProduct } from '../../common/types/webshop.types';
import { useTranslation } from 'react-i18next';

type Props = {
    onSelect: Function,
    selected?: string,
    isRenewalVariant: boolean,
    isSalePrice: boolean,
    price: string,
    compareAt: string,
    selectedVariant: WebProduct
}

export default function QtyStore(props: Props) {
    const {onSelect, isRenewalVariant, isSalePrice, price, compareAt, selectedVariant} = props;
    const { t } = useTranslation(['checkout', 'common'])

    const handleSelect = (event: any) => {
        onSelect(event);
    }

    if (!selectedVariant){
        return <></>
    }

    return (
        <div className='row' style={{marginTop: '24px'}}>
            <div className='col-lg-4 col-12 d-flex'>
                <div style={{marginTop: 'auto', marginBottom: 'auto'}}>
                    <button disabled={isRenewalVariant} data-qty="subtract" className="btn qty-button"
                            onClick={handleSelect}>-
                    </button>
                </div>
                <div className="form-group" style={{marginTop: 'auto', marginBottom: 'auto'}}>
                    <input disabled={isRenewalVariant} id="purchase-qty" name="quantity" className='form-control'
                           onChange={handleSelect} defaultValue={1}/>
                </div>
                <div style={{marginTop: 'auto', marginBottom: 'auto'}}>
                    <button disabled={isRenewalVariant} data-qty="add" className="btn qty-button"
                            onClick={handleSelect}>+
                    </button>
                </div>
            </div>
            <div className="col-lg-auto col-12 d-flex flex-column justify-content-end">
                {!isSalePrice && (
                    <div><span className='price-header'>Price: </span><span
                        className="standard-price">{price} USD</span></div>
                )}
                {isSalePrice && (
                    <>
                        <div><span><s>Price: {compareAt} USD</s></span></div>
                        <div><span className="sale-price">SALE PRICE: {price} USD</span></div>
                    </>
                )}
                <div><span>SKU: {selectedVariant.sku}</span></div>
            </div>
        </div>
    )
}